module.exports = __webpack_public_path__ + "static/media/rates.c34c0db8.png";